import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import LandingPage from './pages/LandingPage';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import StockPage from './pages/StockPage';
import OrderStatement from './pages/OrderStatement';
import ActivityLog from './pages/ActivityLog';
import Analytics from './pages/Analytics';
import UserManagement from './pages/UserManagement';
import Layout from './components/Layout';
import Settings from './pages/Settings';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

function ProtectedRoute({ children }) {
  const { currentUser } = useAuth();
  return currentUser ? <Layout>{children}</Layout> : <Navigate to="/" />;
}

function App() {
  const { currentUser } = useAuth();

  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/"       element={currentUser ? <Navigate to="/dashboard" /> : <LandingPage />} />
        <Route path="/login"  element={currentUser ? <Navigate to="/dashboard" /> : <LandingPage />} />
        <Route path="/signup" element={currentUser ? <Navigate to="/dashboard" /> : <Signup />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/tos"     element={<TermsOfService />} />

        {/* Protected — dashboard is now default */}
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/stock"     element={<ProtectedRoute><StockPage /></ProtectedRoute>} />
        <Route path="/orders"    element={<ProtectedRoute><OrderStatement /></ProtectedRoute>} />
        <Route path="/log"       element={<ProtectedRoute><ActivityLog /></ProtectedRoute>} />
        <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
        <Route path="/users"     element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
        <Route path="/settings"  element={<ProtectedRoute><Settings /></ProtectedRoute>} />

        <Route path="*" element={<Navigate to={currentUser ? "/dashboard" : "/"} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;